import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { SessionExpiredError } from '@/lib-backend/SessionAdminApiClient';
import { AdminApiError, InvalidAuthTokenError } from '@/lib-backend';
import { NotificationService } from '@/app/services/notification.service';
import { HttpTransportError } from '@/app/utils/http-errors';

export function handleApiError(error: unknown, router: Router, notification?: NotificationService): void {
    if (error instanceof SessionExpiredError || error instanceof InvalidAuthTokenError) {
        router.navigate(['/auth/login']);
        return;
    }
    if (error instanceof HttpTransportError) {
        if (error.status === 413) {
            console.error('Upload rejected: payload too large (HTTP 413)');
            notification?.show({
                severity: 'error',
                summary: 'File too large',
                detail: 'The selected file exceeds the maximum upload size. Please choose a smaller file.',
            });
            return;
        }
        console.error(`HTTP transport error ${error.status}`);
        notification?.show({
            severity: 'error',
            summary: 'Request failed',
            detail: `The server returned an error (HTTP ${error.status}). Please try again.`,
        });
        return;
    }
    if (error instanceof AdminApiError) {
        console.error(`API error ${error.code}: ${error.message}`);
        notification?.show({
            severity: 'error',
            summary: 'API Error',
            detail: error.message || `Error code: ${error.code}`,
        });
        return;
    }
    console.error('Unexpected error', error);
    notification?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'An unexpected error occurred. Please try again.',
    });
}
